import { Type } from "class-transformer";
import { BehaviorSubject } from "rxjs";
import { ModelModel } from "./api-models/model";
import { ConfigurationModel } from "./configuration";
import { CustomizerSummaryModel } from "./customizer-summary-model";
import { ManualConfigVariants } from "./manualconfigvariant";
import { ModelGroupModel } from './model-group';
import { ModelSizeModel } from "./model-size";
import { TempleInclinationEnum } from "./variant-temple-inclination";

export class ManualConfig {

	Id: number;
	Uuid: string;
	Group: number;

	@Type(() => Date)
	Release: Date;

	ImageCode: string;

	@Type(() => ModelGroupModel)
	ModelGroup: ModelGroupModel;

	@Type(() => ModelModel)
	Model: ModelModel;

	@Type(() => ModelSizeModel)
	ModelSize: ModelSizeModel;

	@Type(() => ConfigurationModel)
	ModelConfiguration: ConfigurationModel;

	@Type(() => ManualConfigVariants)
	ManualConfigVariants: Array<ManualConfigVariants>;

	TempleInclination?: TempleInclinationEnum;
	ManualConfigCollectionId: number;
	FavoriteUuid: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(null);
	IsSavingToBag: boolean;
	ShowAddedToBag: boolean;
	IsAddingToTestBag: boolean;
	ShowStartKitAddedToBag: boolean;
	HasBeenDeleted: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
	IsInCollection: boolean;
	IsPrecious: boolean;
	InvalidatedAt: Date;
	InvalidatedReason: string;
	SummaryModels: Array<CustomizerSummaryModel>;
	HitCount: number;
	imageUrl: string;
	imageUrlRimlessSide: string;

}

export class ManualConfigHitCountModel {

	ManualConfigCollectionId: number;
	ModelGroupId: number;
	HitCount: number;

}
